import { KnowledgeSyncContract } from '@terra/shared-contracts-knowledge-sync';
import { createTerraOrpcClient } from '@terra/shared-utils';

const SERVICE_NAME = 'orchestrator';

export const knowledgeSyncClient = createTerraOrpcClient({
  contract: KnowledgeSyncContract,
  serviceName: SERVICE_NAME,
});
